import styled from '@emotion/styled'

export const ActionContainer = styled('div')`
  margin-top: 32px;
  min-width: 224px;
`
